import React from 'react';
import { useSpring, animated, config } from 'react-spring';
import styled, { keyframes } from 'styled-components';

// Keyframes for background animation (if needed)
const backgroundAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const PopupBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const PopupContainer = styled(animated.div)`
  width: 600px;
  background: #fff;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  background: linear-gradient(45deg, #f3ec78, #af4261);
  background-size: 200% 200%;
  animation: ${backgroundAnimation} 10s ease infinite;
`;

const Title = styled.h2`
  font-family: 'Comic Sans MS', cursive;
  color: #333;
  margin-bottom: 10px;
  font-size: 36px;
`;

const Subtitle = styled.p`
  font-family: 'Comic Sans MS', cursive;
  color: #333;
  margin-bottom: 20px;
  font-size: 18px;
`;

const Button = styled.button`
  padding: 10px 20px;
  font-size: 18px;
  font-family: 'Comic Sans MS', cursive;
  color: white;
  background-color: #ff6347;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #e5533d;
  }
`;

const ImageContainer = styled.div`
  width: 100px;
  height: 100px;
  margin: 0 auto 20px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

const AdmissionPopup = ({ show, onClose }) => {
  const animation = useSpring({
    opacity: show ? 1 : 0,
    transform: show ? `translateY(0)` : `translateY(-100%)`,
    config: config.wobbly,
  });

  return (
    show && (
      <PopupBackground>
        <PopupContainer style={animation}>
          <ImageContainer>
            <Image src="./popup.png" alt="Admission" />
          </ImageContainer>
          <Title>SCHOOL ADMISSION</Title>
          <Subtitle>Open for Registration</Subtitle>
          <Button onClick={onClose}>ENROLL NOW!</Button>
        </PopupContainer>
      </PopupBackground>
    )
  );
};

export default AdmissionPopup;
